import { Redirect } from "react-router-dom"

import { useFlags } from "src/hooks/useFlags"
import { Routes } from "src/router/routes"

export function GuestDetails({
  homeId,
  guestId,
}: {
  homeId: string
  guestId: string
}) {
  const { enableCompass } = useFlags()

  if (!enableCompass) {
    return <Redirect to={Routes.Dashboard.location()} />
  }

  return (
    <div>
      GuestDetails {homeId} {guestId}
    </div>
  )
}
